export const APP_NAME = 'knowledge-product';
export const SCREENS = {
  MANAGE: 'manage-articles',
  ARTICLE_DETAILS: 'article-post-publish',
  CREATE: 'create-article',
  CATEGORIZE: 'categorize',
  INSIGHTS: 'articles-insights',
  TEMPLATE_EDITOR: 'template-editor',
  KB_AGENT_DASHBOARD: 'kb-agent-dashboard',
  KB_AGENT_SETUP: 'kb-agent-setup'
};